export const LoginPagePasswordSection= `<div id="kc-form" class="tc-form">
        <div class="tc-multiple_logins_warning">
            If TIMOCOM is already active on another device, you will be logged out of that device. Unsaved information could be lost.
        </div>
        <div id="input-error-container-credentials">
        
                                <span id="error-image-content" class="pf-v5-c-helper-text__item-text pf-m-error kc-feedback-text">
                                    <span class="pf-v5-c-form-control__icon pf-m-status">
                                      <img src="/resources/img/error-icon.png" alt="error"/>
                                    </span>
                                    Your e-mail address or password is incorrect. Please try again.
                                </span>
        </div>

          <div id="kc-form-wrapper">









                <form id="kc-form-login" class="pf-v5-c-form pf-v5-u-w-100 tc-form" novalidate="novalidate">

<div class="pf-v5-c-input-group tc-display-username">
    <label for="username" class="pf-v5-c-form__label tc-label">E-mail address</label>
    <div>
        <div class="pf-v5-c-input-group__item pf-m-fill">
                                    <span class="pf-v5-c-form-control pf-m-readonly">
                                          <input id="username" name="username" value="" readonly="">
                                    </span>
            <div class="pf-v5-c-input-group__item">
                <button id="reset-login" class="pf-v5-c-button pf-m-control kc-login-tooltip" type="button" aria-label="Restart login">
                    <img src="/resources/img/reset.png" alt="reset" />
                    <span class="kc-tooltip-text">Restart login</span>
                </button>
            </div>
        </div>


<div class="pf-v5-c-form__group">
    <div class="pf-v5-c-form__group-label pf-v5-u-pb-xs">
        <label for="password" class="pf-v5-c-form__label">
        <span class="pf-v5-c-form__label-text">
            Password
        </span>
        </label>
    </div>

    <div class="pf-v5-c-input-group">
      <div class="pf-v5-c-input-group__item pf-m-fill">
        <span class="pf-v5-c-form-control ">
          <input id="password" name="password" value="" type="password" autocomplete="current-password" aria-invalid="">
        </span>
      </div>
      <div class="pf-v5-c-input-group__item">
        <button class="pf-v5-c-button pf-m-control" type="button" id="password-show-password">
             <img src="/resources/img/showPass.png" alt="password" />
        </button>
      </div>
    </div>
    <div class="pf-v5-c-form__helper-text" aria-live="polite">
        <div class="pf-v5-c-helper-text pf-v5-u-display-flex pf-v5-u-justify-content-space-between">
        </div>
    </div>


    <div id="input-error-container-password">
    </div>
</div>


                    <span class="pf-v5-c-helper-text__item-text"><a tabindex="5" href="https://my.timocom.com/app/weblogin/requestpassword.html" data-testid="requestPassword">Forgot your password?</a></span>
                    <input type="hidden" id="id-hidden-input" name="credentialId">
  <div class="pf-v5-c-form__group">
    <div class="pf-v5-c-form__actions pf-v5-u-pt-xs pf-v5-u-flex-wrap">
    <button class="pf-v5-c-button pf-m-primary pf-m-block " id="kc-login-send-data">
      Sign In
    </button>
    </div>
  </div>
                
    <div class="pf-v5-c-helper-text__item-text">
        <br>
        <span><a href="https://www.timocom.com/registerCustomer/en" data-testid="lnk_register_customer" target="_blank">
                            You are a new customer and not yet registered? Register here</a></span>
        <br>
        <span><a href="https://www.timocom.com/registerUser/en" data-testid="lnk_register_user" target="_blank">You are already a customer and wish to add a new user? Add here</a></span>
    </div>
            </div>
        </div>
        </form>

                            <div class="pf-v5-c-login__main-footer">
<!-- template: login.ftl -->
  <div class="pf-v5-c-login__main-footer-band">
      <span class="pf-v5-c-login__main-footer-band-item pf-v5-u-font-size-sm pf-v5-u-color-200">
          Or sign in with
      </span>
  </div>
  <div id="kc-social-providers" class="">
      <ul class="pf-v5-c-login__main-body pf-v5-u-pl-0 pf-v5-u-pr-0 ">
              <li class="pf-v5-u-pb-sm">
                  <a data-once-link="" data-disabled-class="pf-m-aria-disabled" id="social-timocomAD" class="pf-v5-c-button pf-m-secondary pf-m-block pf-v5-u-display-flex pf-v5-u-align-items-center pf-v5-u-justify-content-space-between" aria-label="TIMOCOM Entra ID Login" type="button" href="/realms/timocom/broker/timocomAD/login?client_id=web-ui-public-login&amp;tab_id=H-ocMfa8ZqQ&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiJhNGE3ZjVjZC02NjZmLTQyMTMtOTQ4ZC05MGExZTZmZGRjYjcifQ&amp;session_code=ImiGpEZhnyjF2vVCHWZ1HONHNKQQZ2GfvhWdPmWYt8A">
                                <svg viewBox="0 0 512 512" aria-hidden="true">
                                    <path d="M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"></path>
                                </svg>
                            <span class="pf-v5-u-m-auto">TIMOCOM Entra ID Login</span>
                  </a>
              </li>
      </ul>
  </div>

                            </div>
                        </div>
                    </div>`;

export const LoginPageUsernameSection = `
<div id="kc-form-wrapper">
                    <form id="kc-form-login" class="pf-v5-c-form pf-v5-u-w-100">
                           <div class="tc-multiple_logins_warning">
                               If TIMOCOM is already active on another device, you will be logged out of that device. Unsaved information could be lost.
                           </div>
                                               <div class="pf-v5-c-form__group">
                   
                   <div class="pf-v5-c-form__group">
                       <div class="pf-v5-c-form__group-label pf-v5-u-pb-xs">
                           <label for="username" class="pf-v5-c-form__label">
                           <span class="pf-v5-c-form__label-text">
                                                                   Username
                   
                           </span>
                           </label>
                       </div>
                   
                       <span class="pf-v5-c-form-control ">
                           <input id="username" name="username" value="" type="text" autocomplete="username" autofocus="" aria-invalid="">
                       </span>
                   
                       <div id="input-error-container-username">
                       </div>
                   </div>
                   
                   
                                               </div>
                   
                                           <div class="pf-v5-c-form__group">
                                           </div>
                   
                   
                     <div class="pf-v5-c-form__group">
                       <div class="pf-v5-c-form__actions pf-v5-u-pt-xs pf-v5-u-flex-wrap">
                     <button class="pf-v5-c-button pf-m-primary pf-m-block " name="login" id="kc-login">
                     Sign In
                     </button>
                       </div>
                     </div>
                                       </form>
                                       <div class="pf-v5-c-helper-text__item-text">
                  <br>
                  <span><a href="https://www.timocom.com/registerCustomer/en" data-testid="lnk_register_customer" target="_blank">
                                      You are a new customer and not yet registered? Register here</a></span>
                  <br>
                  <span><a href="https://www.timocom.com/registerUser/en" data-testid="lnk_register_user" target="_blank">You are already a customer and wish to add a new user? Add here</a></span>
              </div>
              </div>
` 

export const LoginPageSection = `
        <div class="pf-v5-c-login">
            <div class="pf-v5-c-login__container">
                <main class="pf-v5-c-login__main">
                    <div class="pf-v5-c-login__wrapper">
                        <header id="kc-header" class="pf-v5-c-login__header">
                            <div id="kc-header-wrapper" class="pf-v5-c-brand"></div>
                        </header>
                        <div class="pf-v5-c-login__main-header">
                            <h1 class="pf-v5-c-title pf-m-3xl" id="kc-page-title">Login</h1>
                            <div class="pf-v5-c-login__main-header-utilities">
                                <div class="pf-v5-c-form-control">
                                    <select aria-label="languages" id="login-select-toggle" onchange="if (this.value) window.location.href=this.value">
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=cs">
                                                Čeština
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=da">
                                                Dansk
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=de">
                                                Deutsch
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=en" selected="">
                                                English
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=es">
                                                Español
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=fr">
                                                Français
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=hr">
                                                Hrvatski
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=it">
                                                Italiano
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=lt">
                                                Lietuvių
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=hu">
                                                Magyar
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=nl">
                                                Nederlands
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=no">
                                                Norsk
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=pl">
                                                Polski
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=pt">
                                                Português
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=ro">
                                                Română
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sk">
                                                Slovenčina
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sl">
                                                Slovenščina
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=fi">
                                                Suomi
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sv">
                                                Svenska
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=tr">
                                                Türkçe
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=el">
                                                Ελληνικά
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=bg">
                                                Български
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=ru">
                                                Русский
                                            </option>
                                            <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sr">
                                                Српски
                                            </option>
                                    </select>
                                        <span class="pf-v5-c-form-control__utilities">
                            <span class="pf-v5-c-form-control__toggle-icon">
                                <svg class="pf-v5-svg" viewBox="0 0 320 512" fill="currentColor" aria-hidden="true" role="img" width="1em" height="1em">
                                <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z">
                                </path>
                                </svg>
                            </span>
                            </span>
                                    </div>
                                </div>
                        </div>
                        <div class="pf-v5-c-login__main-body">
<!-- template: login-username.ftl -->

        <div id="kc-form">
            












              





        </div>


                            <div class="pf-v5-c-login__main-footer">
<!-- template: login-username.ftl -->


                            </div>
                        </div>
                    </div>
                    <div class="pf-v5-c-login__main-footer tc-login-main-footer">
        <div>
            <span>TIMOCOM GmbH /</span>
            <span><a href="/" target="_blank" data-testid="footer-timocomLink">www.timocom.com</a> /</span>
            <span>
            <a href="/impress/en" target="_blank" data-testid="footer-imprintLink">Legal notice</a> /
        </span>
            <span>
            <a href="/dataProtection/en" target="_blank" data-testid="footer-privacyLink">Data protection</a> /
        </span>
            <span>
            <a href="/gtc" target="popup" onclick="window.open('/gtc','agb_link','width=800,height=600')" data-testid="footer-gtcLink">terms and conditions</a>
        </span>
            <div>
            <span class="tc-footer-underline">Any questions? Contact our
                <a href="/contact/en" target="_blank" data-testid="footer-contactLink">
                    customer service team.</a>.</span>
            </div>
        </div>
                    </div>
                </main>
  <main data-testid="adTeaser" class="tc-teaser tc-teaser--active tc-teaser-phishing pf-v5-c-login__main">
    <a href="/help-center/security?utm_source=marketplace&amp;utm_medium=banner" target="_blank" rel="noopener noreferrer" class="tc-teaser-phishing__link tc-teaser-phishing__body">
      <header id="kc-header" class="pf-v5-c-login__header">
      </header>
      <div class="pf-v5-c-login__main-header">
          <div class="pf-v5-c-login__main-header-utilities language-selector">
            <div class="pf-v5-c-form-control">
              <select aria-label="languages" id="login-select-toggle" tabindex="-1" onchange="if (this.value) window.location.href=this.value">
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=cs">
                    Čeština
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=da">
                    Dansk
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=de">
                    Deutsch
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=en" selected="">
                    English
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=es">
                    Español
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=fr">
                    Français
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=hr">
                    Hrvatski
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=it">
                    Italiano
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=lt">
                    Lietuvių
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=hu">
                    Magyar
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=nl">
                    Nederlands
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=no">
                    Norsk
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=pl">
                    Polski
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=pt">
                    Português
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=ro">
                    Română
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sk">
                    Slovenčina
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sl">
                    Slovenščina
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=fi">
                    Suomi
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sv">
                    Svenska
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=tr">
                    Türkçe
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=el">
                    Ελληνικά
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=bg">
                    Български
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=ru">
                    Русский
                  </option>
                  <option value="/realms/timocom/login-actions/authenticate?client_id=web-ui-public-login&amp;tab_id=MZGsp0Q4II8&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiI0MGJlYjI4YS00M2U1LTQxNTQtOTcwNi0wYWQzODk4OGNkODAifQ&amp;execution=66db79ac-3efc-40d0-bee4-0d1cc9fec0f9&amp;kc_locale=sr">
                    Српски
                  </option>
              </select>
              <span class="pf-v5-c-form-control__utilities">
                <span class="pf-v5-c-form-control__toggle-icon">
                  <svg class="pf-v5-svg" viewBox="0 0 320 512" fill="currentColor" aria-hidden="true" role="img" width="1em" height="1em">
                    <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z">
                    </path>
                  </svg>
                </span>
              </span>
            </div>
          </div>
      </div>
      <div class="pf-v5-c-login__main-body">
        <div id="kc-form" class="tc-form">
          <div id="kc-form-wrapper">
            <div class="pf-v5-c-form__group">
              <div class="pf-v5-c-form__group-label pf-v5-u-pb-xs">
                <label for="username" class="pf-v5-c-form__label">
                  <span class="pf-v5-c-form__label-text">
                    E-Mail-Address
                  </span>
                </label>
              </div>
              <span class="pf-v5-c-form-control ">
                <input id="phished_name" name="phished_name" value="" tabindex="-1" autocomplete="off" type="text" aria-invalid="">
              </span>
              <div id="input-error-container-username">
              </div>
            </div>
            <div>
              <div class="mt-2 pf-v5-c-helper-text__item-text tc-teaser-phishing--emphasized">
                Real or fake? Spot phishing at a glance!
              </div>
              <div class="colorize mb-1">
                Quick tips for a secure TIMOCOM workday.
              </div>
            </div>
            <div class="pf-v5-c-form__group">
              <div class="pf-v5-c-form__actions pf-v5-u-pt-xs pf-v5-u-flex-wrap">
                <button class="pf-v5-c-button pf-m-primary pf-m-block " name="login" type="button" tabindex="-1">
                  Protect yourself now
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </a>
  </main>
      <link rel="stylesheet" href="/resources/css/teaser-phishing.css">
            </div>
        </div>
`
export const LoginPageVerifySection= `<div id="kc-form" class="tc-form">
        <div id="input-error-container-credentials">
        
                                <span id="error-image-content" class="pf-v5-c-helper-text__item-text pf-m-error kc-feedback-text">
                                    <span class="pf-v5-c-form-control__icon pf-m-status">
                                      <img src="/resources/img/error-icon.png" alt="error"/>
                                    </span>
                                    <p id="error-text"></p>
                                </span>
        </div>
        <div class="tc-multiple_logins_warning">
            <h2 class="info__headline">Unknown browser</h3>
           In order to identify the browser used, we have sent a message containing a validation code to the following email address:
           <div><span id="verify-email-address"></span></div>
           <div class="info__text">Please enter the code in the field below!</div>
        </div>





<form id="kc-email-tan-form-login" class="pf-v5-c-form pf-v5-u-w-100" action="https://iam.timocom.com/realms/timocom/login-actions/authenticate?session_code=LGt3_r9nj5eFeY3ciEEEq-5hfGgDN0_XEJRDF3GCfmU&amp;execution=2d068a68-2233-4658-98f8-68d2ae321656&amp;client_id=web-ui-public-login&amp;tab_id=SvADkMl_yEA&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiJmY2NmMTZlZS0xZjI1LTQ3OGUtODU4ZC04OGIxMDM1NDE3MmMifQ" method="post">
            <div class=" tan-input__container">
                <label for="code" class="tan-input__label"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">Validation code
                </font></font></label>
                <div class="tan-input" style="position: relative; display: flex;">
      
                    <div class="verify-content-lock"></div>

                    <input id="tan" data-testid="tan" type="text" name="code" minlength="6" maxlength="6" placeholder="------" class="tan-input__input" autofocus="" required="">
                </div>
            </div>
            <div class=" checkbox__container">
                <input id="rememberBrowser" data-testid="rememberBrowser" name="rememberBrowser" type="checkbox">
                <span class="checkbox__checkmark"></span>
                <label for="rememberBrowser" class="checkbox__label"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">
                    Trusted browser approval
                </font></font></label>
            </div>
            <div class="pf-v5-c-form__group ">
                <div id="kc-form-buttons" class=" tan-actions">
                    <font dir="auto" style="vertical-align: inherit;">
                      <font dir="auto" style="vertical-align: inherit;">
                        <input type="button" id="kc-send-code" class="pf-v5-c-button pf-v5-c-button pf-m-primary pf-m-block " value="Send ">
                      </font>
                      <font dir="auto" style="vertical-align: inherit;">
                        <input type="button" id="request-new-code" class="pf-v5-c-button  pf-m-block " value="Resend email">
                      </font>
                    </font>
                   
                    <font dir="auto" style="vertical-align: inherit;"></font>
                </div>
                <div id="kc-form-options" class=" flow-actions">
                    <div class="">
                        <span><a href="/realms/timocom/login-actions/restart?client_id=web-ui-public-login&amp;tab_id=SvADkMl_yEA&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiJmY2NmMTZlZS0xZjI1LTQ3OGUtODU4ZC04OGIxMDM1NDE3MmMifQ&amp;skip_logout=false"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">« Back to login</font></font></a></span>
                    </div>
                </div>
            </div>
        </form>








       

                            <div class="pf-v5-c-login__main-footer">
<!-- template: login.ftl -->
  <div class="pf-v5-c-login__main-footer-band">
      <span class="pf-v5-c-login__main-footer-band-item pf-v5-u-font-size-sm pf-v5-u-color-200">
          Or sign in with
      </span>
  </div>
  <div id="kc-social-providers" class="">
      <ul class="pf-v5-c-login__main-body pf-v5-u-pl-0 pf-v5-u-pr-0 ">
              <li class="pf-v5-u-pb-sm">
                  <a data-once-link="" data-disabled-class="pf-m-aria-disabled" id="social-timocomAD" class="pf-v5-c-button pf-m-secondary pf-m-block pf-v5-u-display-flex pf-v5-u-align-items-center pf-v5-u-justify-content-space-between" aria-label="TIMOCOM Entra ID Login" type="button" href="/realms/timocom/broker/timocomAD/login?client_id=web-ui-public-login&amp;tab_id=H-ocMfa8ZqQ&amp;client_data=eyJydSI6Imh0dHBzOi8vbXkudGltb2NvbS5jb20vYXBwL3RjZ2F0ZS8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiJhNGE3ZjVjZC02NjZmLTQyMTMtOTQ4ZC05MGExZTZmZGRjYjcifQ&amp;session_code=ImiGpEZhnyjF2vVCHWZ1HONHNKQQZ2GfvhWdPmWYt8A">
                                <svg viewBox="0 0 512 512" aria-hidden="true">
                                    <path d="M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"></path>
                                </svg>
                            <span class="pf-v5-u-m-auto">TIMOCOM Entra ID Login</span>
                  </a>
              </li>
      </ul>
  </div>

                            </div>
                        </div>
                    </div>`;
